/**
 * Types partagés pour les composants de la page Gestion des rôles.
 */

import { Scope } from '../../shared/permissions';

export interface RoleSummary {
  id: string;
  name: string;
  display_name: string;
  color: string | null;
  description: string | null;
  is_system: boolean;
  is_default: boolean;
  position: number | null;
  member_count: number;
}

export interface RolePermission {
  permission: string;
  scope: Scope;
}

export interface RoleDetail extends RoleSummary {
  permissions: RolePermission[];
}

export interface RoleMember {
  id: string;
  auth_user_id: string | null;
  external_id: string | null;
  first_name: string | null;
  last_name: string | null;
  company_name: string | null;
  is_active: boolean;
  establishment_id?: string | null;
  establishments?: { name: string | null; dossier: string | null } | null;
}

export const COLOR_PALETTE: string[] = [
  '#dc2626', '#ea580c', '#d97706', '#ca8a04', '#65a30d', '#16a34a',
  '#059669', '#0891b2', '#0284c7', '#2563eb', '#4f46e5', '#7c3aed',
  '#9333ea', '#c026d3', '#db2777', '#e11d48', '#475569', '#1f2937'
];

export const DEFAULT_ROLE_COLOR = '#94a3b8';

export const API_BASE: string = (import.meta as { env?: { VITE_API_BASE_URL?: string } }).env?.VITE_API_BASE_URL || window.location.origin;

export function getToken(): string | null {
  return localStorage.getItem('sso_token');
}

export function authHeaders(): Record<string, string> {
  const token = getToken();
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {})
  };
}

export function slugify(s: string): string {
  return s
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_|_$/g, '');
}

export const ROLE_NAME_REGEX = /^[a-z][a-z0-9_]*$/;
